export default "__VITE_ASSET__Ba1jl9OR__"